export default __webpack_public_path__ + "static/media/meeting.e4395cea.svg";